import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeagueDetail} from '../../../apis/league/getLeagueDetail'

const useQueryLeagueDetail = (id: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.league.getLeagueDetail(id),
        queryFn: async () => {
            const {data} = await getLeagueDetail(id)
            return data
        },
        enabled: !!id,
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryLeagueDetail
